import { useEffect, useRef } from "react";
import { recordWantAdViews } from "@/services/v2/wantAdService";
import { utcDay } from "@/helpers/reachViewer";

const sentKey = (wantAdId) => `wantad-viewed-${wantAdId}-${utcDay()}`;

export const useRecordWantAdView = (
  wantAdId,
  { skip = false, send = recordWantAdViews, entry = null } = {},
) => {
  const entryRef = useRef(entry);
  entryRef.current = entry;

  useEffect(() => {
    const id = Number(wantAdId);
    if (!id || skip) return;
    try {
      if (window.sessionStorage.getItem(sentKey(id))) return;
      window.sessionStorage.setItem(sentKey(id), "1");
    } catch {
      return;
    }
    send([id], entryRef.current);
  }, [wantAdId, skip, send]);
};

export default useRecordWantAdView;
